// extracted by mini-css-extract-plugin
export default {"competitorSelect":"CompetitorSelect_competitorSelect__-fpj5","confirmCompetitorsButton":"CompetitorSelect_confirmCompetitorsButton__LXqLj"};